// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"2bd7bd72","796":"fe251c56"}[chunkId] + ".chunk.js";
};